import React, { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import MainContent from './components/MainContent';
import DonatePage from './components/DonatePage_NEW';
import './components/DonatePage_NEW.css';

function App() {
  const [currentPage, setCurrentPage] = useState<'main' | 'donate'>('main');

  const handleCloseDonate = () => {
    setCurrentPage('main');
  };

  return (
    <div className="App">
      <Navbar onPageChange={setCurrentPage} currentPage={currentPage} />
      {currentPage === 'main' ? <MainContent /> : <DonatePage onClose={handleCloseDonate} />}
    </div>
  );
}

export default App;